import { render } from "./AbsPopup.vue?vue&type=template&id=7f20ea89&scoped=true&ts=true"
import script from "./AbsPopup.vue?vue&type=script&lang=ts"
export * from "./AbsPopup.vue?vue&type=script&lang=ts"

import "./AbsPopup.vue?vue&type=style&index=0&id=7f20ea89&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f20ea89"]])

export default __exports__